import React from "react";
import {connect} from "react-redux";
@connect ((store) =>{
	return {
	  messages: store.messages.messages
	}
})
export default class FooterComponent extends React.Component {
    render() {
        const {messages} = this.props;
        return (
          
            <footer>

            </footer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/opencell/pages/FooterComponent.jsx